import {AutogenLayoutScoreCardControl} from "./autogen/AutogenLayoutScoreCardControl";
import {
    DataSource,
    DataSourceMode,
    DropdownSelectionEvent,
    LayoutProps,
    LookupModelSelectionEvent, TableRow, TableRowBeforeSaveEvent,
    Textbox
} from "@mcleod/components";
import {ModelRow, ModelRowType, StringUtil} from "@mcleod/core";


interface ControlLayoutProps extends LayoutProps {
    vendorId: string;
}

export class ScoreCardControl extends AutogenLayoutScoreCardControl{

    constructor(props?: Partial<ControlLayoutProps>) {
        super(props);
    }

    async onLoad() {
        this.mainDataSource.addAfterModeChangeListener(event =>{
            if(event.newMode === DataSourceMode.ADD) {
                this.mainDataSource.activeRow._appending = false;
            }
        });
    }

    async postDataSources(vendorId: string): Promise<boolean> {
        try {
            this.mainDataSource?.activeRow?.set("vendor_id", vendorId);
            if(this.mainDataSource.mode == DataSourceMode.ADD){
                this.mainDataSource.activeRow._appending = true;
            }
            await this.mainDataSource.post();
            return true;
        } catch (error) {
            return false;
        }
    }


    tableReasonCodesMappingBeforeRowSave(event: TableRowBeforeSaveEvent) {
        const modelRow = event.getTableRow().data as ModelRow;
        modelRow.set("code_type", "ISO");
    }

    textboxOrderTypeBeforeLookupModelSearch(event) {
        event.filter.is_active = 'Y';
    }

    textboxDisplayValueBeforeLookupModelSearch(event) {
        event.filter.code_type = "DelayReason";
    }
}
